import User from "@/data/models/User";

/**
 * `getEffectiveUser()` (`@/utils/ViewAs`) for low-level modules: data models, repositories and the
 * graph extractor (ticket 2610052).
 *
 * They cannot import `@/utils/ViewAs` at the top: it reaches the Vuex store, so loading it while one
 * of them is still loading runs a store module's property initializers against modules that have not
 * finished either. That blanked the whole app (a `createDefaultCompanySettings` call into a
 * half-loaded `Client.ts`; CLAUDE.md pitfall 9). Requiring it at call time, as `clearCacheAndModules`
 * in `Utils.ts` does for the same reason, keeps it out of the load order.
 */
export function getEffectiveUserLazily(): User | null {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const { getEffectiveUser } = require("@/utils/ViewAs");

  return getEffectiveUser();
}
